import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { JobStatusDetail, JobStatusProcessing, JobStatus } from '../../models/progress.model';
import { Dialog, DialogModule } from 'primeng/dialog';
import { BadgeModule } from 'primeng/badge';
import { CommonModule } from '@angular/common';
import { ProgressService } from '../../services/progress.service';
import { ProgressStateService } from '../../services/progressstate.service';
import { ImportStatusModel, ImportDemo, ImportLimitSets } from '../../../shared/models/importstatus.model';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { EfMessageService } from 'src/app/core/common/toast-outlet/ef-message.service';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { FileDownloadComponent } from 'src/app/file-download/file-download.component';
import { SearchParametertestService } from '../../services/search-parametertest.service';
import { ExportCsvService } from '../../services/export-csv.service';
@Component({
  selector: 'app-progressbar',
  imports: [DialogModule, BadgeModule, CommonModule, ProgressSpinnerModule, TranslatePipe, FileDownloadComponent],
  templateUrl: './progressbar.component.html',
  styleUrl: './progressbar.component.scss'
})
export class ProgressbarComponent implements OnInit {
  public areSchematicValidationRulesValid = false;
  public hasRowNumber = false;
  public progressData: any;
  public jsonData: any;
  public jsonResponse: any;
  public process: JobStatusDetail[] = [];
  public importStatus: ImportStatusModel[] = [];
  public displayProcess = false;
  public isCollapsed = false;
  public processStatus = JobStatus;
  public totalValue = 100;
  public intervalTime = 100;
  public importDemoList: ImportDemo[] = [];
  public importLimitSetList: ImportLimitSets[] = [];
  public showImportStatusDialog = false;
  public selectedViewStatusFileId = '';
  public showSuccessInfo = false;
  public showFailednfo = false;
  public showSyntaxErrornfo = false;
  public showValidationErros = false;
  public showNoChangesInfo = false;
  public isGroupUpload = false;

  public updateCount = 0;
  public noChangesInfo = '';
  public createdInfo = '';
  public updatedInfo = '';
  public successInfo = '';
  public syntaxInfo = '';
  public syntaxInfolimit = '';
  public permissionInfo = '';
  public permissionInfolimits = '';
  public validationerrorrules = [];
  public rules = [{ RuleName: 'Rule1', RowNumber: '1', Error: 'Error1' }];
  public failedInfo = '';
  public failedInfoInvalidStructure = '';
  public validationDetails: Array<any> = [];
  public nameCountMap = new Map<string, number>();
  public enTranslationMandatoryCount = 0;
  public translateService: TranslateService = inject(TranslateService);
  public isDownloadTemplateProcess = false;
  public isDownloadCustomLimitSetProcess = false;
  public isDownloadGroupsProcess = false;
  public CODE_PREFIX = 'vbei';
  public DOWNLOAD_PROGRESS_COMPLETED = 100;
  @ViewChild(FileDownloadComponent) public fileDownloadComponent!: FileDownloadComponent;
  constructor(
    public progressService: ProgressService,
    public progressStateService: ProgressStateService,
    public efMessageService: EfMessageService,
    public searchParameterTestService: SearchParametertestService,
    private readonly exportCsvService: ExportCsvService
  ) {}
  public isProcessing = false;
  public idsToProcessing: JobStatusProcessing[] = [];
  @ViewChild('browseDialog', { static: true }) public browseDialog!: Dialog;

  public ngOnInit(): void {
    this.progressStateService.getIsGroupUploadState().subscribe((isGroupUpload) => {
      this.isGroupUpload = isGroupUpload;
    });
    this.registerExportsChange();
  }

  public registerExportsChange(): void {
    this.progressService.onProcessReceived().subscribe((res: JobStatusDetail[]) => {
      this.process = res;
      this.checkAndDisplayExports(res);

      if (this.displayProcess && this.process.length >= 1 && !this.isProcessing) {
        this.idsToProcessing = this.process
          .filter((l) => l.status === JobStatus.New)
          .map(
            (l) =>
              new JobStatusProcessing({
                id: l.id ? l.id : '',
                status: JobStatus.New
              })
          );

        if (this.idsToProcessing) {
          this.validationDetails.length = 0;
          this.showValidationErros = false;
          this.showSyntaxErrornfo = false;
          this.failedInfo = '';
          this.processJobs(this.idsToProcessing);
        }
      }
    });

    this.progressService.onProcessStatusRecieved().subscribe((res: any) => {
      if (res === JobStatus.Completed || res === JobStatus.Failed || res === JobStatus.Partially) {
        const downloadLimitSetText = this.translateService.instant('vbeiDownloadLimitSet');
        const downloadGroupsText = this.translateService.instant('vbeiDownloadGroups');
        const process = this.process.find((p) => p.name === downloadLimitSetText || p.name === downloadGroupsText);

        if (!process) {
          const key = this.isGroupUpload ? 'vbeiGroupsToasterUploadSuccess' : 'vbeiToasterUploadSuccess';
          this.efMessageService.success({ detail: this.translateService.instant(key) });
          this.progressStateService.setProgressState(false);
          return;
        }
        const isCompleted = res === JobStatus.Completed;
        const isTargetProcess = process.name === downloadLimitSetText || process.name === downloadGroupsText;
        const isProcessReady = process.progress >= 100;
        const processId = process.id;

        if (isCompleted && isTargetProcess && isProcessReady && processId) {
          this.downloadCsvContent(processId);
        }
      }
    });
  }

  public downloadCsvContent(requestCode: string): void {
    this.exportCsvService.getCustomRpCsvContent(requestCode).subscribe({
      next: (response) => {
        const byteArray = response.data;
        const uint8Array = new Uint8Array(byteArray);
        const text = new TextDecoder('utf-8').decode(uint8Array);
        this.exportCsvService.downloadRawCSV(text);
      },
      error: (_error) => {}
    });
  }
  public async processJobs(idsToProcessing: JobStatusProcessing[]): Promise<void> {
    for (const item of idsToProcessing) {
      const index = this.process.findIndex((l) => l.id === item.id);
      await this.startIncrement(index);
    }
  }

  public async checkQueue(): Promise<void> {
    this.idsToProcessing = this.process
      .filter((l) => l.status === JobStatus.New)
      .map(
        (l) =>
          new JobStatusProcessing({
            id: l.id,
            status: JobStatus.New
          })
      );
    if (this.idsToProcessing.filter((l) => l.status === JobStatus.New).length > 0) {
      for (const item of this.idsToProcessing) {
        const index = this.process.findIndex((l) => l.id === item.id);
        await this.startIncrement(index);
      }
    } else {
      this.isProcessing = false;
    }
  }

  public anyStatusChanged(res: JobStatusDetail[]): boolean {
    if (this.process.length === 0 && res.length > 0) {
      return true;
    }
    return this.process.length !== res.length || res.some((r) => this.process.some((e) => e.id === r.id && e.status !== r.status));
  }

  public checkAndDisplayExports(res: JobStatusDetail[]): void {
    if (!this.displayProcess) {
      if (this.anyStatusChanged(res)) {
        this.isCollapsed = !this.displayProcess && this.process.length > 0;
        this.displayProcess = true;
      } else if (res.length > 0) {
        this.displayProcess = true;
      }
    }
  }
  public async startIncrement(index: number): Promise<void> {
    const item = this.process[index];
    item.status = this.processStatus.Active;
    this.process[index] = item;
    this.progressService.updateProcess(index, item);

    return new Promise<void>((resolve) => {
      const intervalId = setInterval(async () => {
        if (!item.id) {
          clearInterval(intervalId);
          resolve();
          return;
        }

        this.jsonResponse = item.errorNote;
        if (this.jsonResponse !== null) {
          if (item.progress >= this.totalValue) {
            if (Array.isArray(item.errorNote.status)) {
              item.errorNote.status.forEach((status: { saveStatus: any }) => {
                switch (status.saveStatus) {
                  case 0:
                    item.ValidationFailed++;
                    break;
                  case 1:
                    item.NoChanges++;
                    break;
                  case 2:
                    item.Created++;
                    break;
                  case 3:
                    item.Updated++;
                    break;
                  case 4:
                    item.SaveFailed++;
                    break;
                }
              });
            }
            this.updateCount = item.Created + item.Updated;
            if (item.errorNote?.status?.length === item.Created + item.Updated + item.NoChanges) {
              item.status = JobStatus.Completed;

              this.progressService.sendProcessStatus(JobStatus.Completed);
            } else if (item.Created > 0 || item.Updated > 0) {
              item.status = JobStatus.Partially;
              this.progressService.sendProcessStatus(JobStatus.Partially);
            } else {
              item.status = JobStatus.Failed;
              this.progressService.sendProcessStatus(JobStatus.Failed);
            }
            this.process[index] = item;
            this.progressService.updateProcess(index, item);

            clearInterval(intervalId);
            resolve();
            this.idsToProcessing
              .filter((l) => l.id === item.id)
              .forEach((l) => {
                l.status = this.jsonResponse?.StatusDetails;
                return l;
              });
            if (this.idsToProcessing.filter((l) => l.status === JobStatus.New).length === 0) {
              this.checkQueue();
            }
          }
        }
      }, this.intervalTime);
    });
  }

  public onClose(): void {
    this.displayProcess = false;
    this.progressStateService.setProcess([]);
  }

  public onDownloadClick(requestCode: string): void {
    if (this.isDownloadTemplateProcess && this.fileDownloadComponent) {
      this.fileDownloadComponent.externalData = this.searchParameterTestService.selectedItemForDownlaod;
      this.fileDownloadComponent.downloadFile();
      return;
    }

    if (this.isDownloadCustomLimitSetProcess || this.isDownloadGroupsProcess) {
      this.downloadCsvContent(requestCode);
    }
  }

  public onCollapseExport(): void {
    this.isCollapsed = !this.isCollapsed;
  }

  public getProcess(): JobStatusDetail[] {
    return this.process;
  }

  // Replace the openImportStatusDialog method with this refactored version:

  public openImportStatusDialog(id: any, source: string): void {
    this.initializeDialogState(source);

    if (this.areSchematicValidationRulesValid) {
      this.handleSchematicValidationRules(id);
    } else {
      this.handleNonSchematicValidationRules(id);
    }

    this.handleSpecialErrorCases(id);
    this.finalizeDialogDisplay();
  }

  private initializeDialogState(source: string): void {
    this.areSchematicValidationRulesValid = source === 'bff';
    this.showFailednfo = false;
    this.showValidationErros = false;
    this.showSyntaxErrornfo = false;
    this.showSuccessInfo = false;
    this.showNoChangesInfo = false;
    this.validationDetails = [];
  }

  private handleSchematicValidationRules(id: any): void {
    if (!this.hasValidSchematicStructure(id)) {
      return;
    }

    this.validationDetails = id.error.validations
      .sort((a: any, b: any) => (a.customState?.rowNumber ?? 0) - (b.customState?.rowNumber ?? 0))
      .map((validation: any) => this.createValidationDetail(validation));

    this.updateErrorRuleNameCount();
  }

  private handleNonSchematicValidationRules(id: any): void {
    this.processLimitSetValidations(id);
    this.handleSuccessInfo(id);
  }

  private processLimitSetValidations(id: any): void {
    if (!this.hasValidLimitSetStructure(id)) {
      return;
    }

    id.errorNote.status.forEach((status: any) => {
      this.processValidationErrors(status);
    });
  }

  private processValidationErrors(status: any): void {
    if (!this.hasValidationErrors(status)) {
      return;
    }

    status.validationErrors.validations.forEach((error: any) => {
      if (this.isValidError(error)) {
        this.validationDetails = this.validationDetails || [];
        this.validationDetails.push(this.createValidationDetail(error));
        this.updateErrorRuleNameCount();
      }
    });
  }

  private handleSuccessInfo(id: any): void {
    if (!this.shouldShowSuccessInfo(id)) {
      return;
    }

    this.showSuccessInfo = true;

    // Handle NoChanges info
    if (id?.NoChanges > 0) {
      this.showNoChangesInfo = true;
    }
    this.noChangesInfo = `${id?.NoChanges || ''} ` + this.translateService.instant('vbeiNoChanges');

    this.createdInfo = this.formatCreatedInfo(id?.Created);
    this.updatedInfo = this.formatUpdatedInfo(id?.Updated);
    this.successInfo = this.formatSuccessInfo(id?.Created, id?.Updated);
  }

  private handleSpecialErrorCases(id: any): void {
    if (this.isSpecialErrorCase(id)) {
      this.showFailednfo = true;
      this.failedInfoInvalidStructure = this.translateService.instant('vbeiInvalidStructure');
      return;
    }

    if (this.validationDetails.length > 0) {
      this.handleValidationDetailsDisplay();
    }
  }

  private handleValidationDetailsDisplay(): void {
    if (this.isInvalidStructureError()) {
      this.showFailednfo = true;
      this.failedInfoInvalidStructure = this.translateService.instant('vbeiInvalidStructure');
    } else {
      this.setupValidationErrorsDisplay();
    }
  }

  private setupValidationErrorsDisplay(): void {
    this.showFailednfo = false;
    this.showValidationErros = true;
    this.showSyntaxErrornfo = true;
    this.failedInfo = this.formatFailedInfo();
    this.hasRowNumber = this.checkHasRowNumber();
  }

  private finalizeDialogDisplay(): void {
    this.showImportStatusDialog = true;
  }

  // Helper methods for validation checks
  private hasValidSchematicStructure(id: any): boolean {
    return id?.error?.validations && Array.isArray(id.error.validations);
  }

  private hasValidLimitSetStructure(id: any): boolean {
    return id?.errorNote?.status && Array.isArray(id.errorNote.status);
  }

  private hasValidationErrors(status: any): boolean {
    return status.validationErrors?.validations && Array.isArray(status.validationErrors.validations);
  }

  private isValidError(error: any): boolean {
    return error?.code && error?.msg;
  }

  private shouldShowSuccessInfo(id: any): boolean {
    return id?.errorNote && id?.status && (id?.status === JobStatus.Completed || id?.status === JobStatus.Partially);
  }

  private isSpecialErrorCase(id: any): boolean {
    return id === 'Error: TranslationNotFound' || id === 'Error: InValidColumnName';
  }

  private isInvalidStructureError(): boolean {
    return this.validationDetails.length > 0 && this.validationDetails[0].name === 'EUL302';
  }

  private checkHasRowNumber(): boolean {
    return this.validationDetails.some((v) => v.customState?.rowNumber);
  }

  // Helper methods for formatting
  private createValidationDetail(validation: any): any {
    return {
      customState: validation.customState,
      code: validation.code,
      msg: this.translateService.instant(`${this.CODE_PREFIX}${validation.code}`),
      name: validation.name
    };
  }

  private formatCreatedInfo(created: number): string {
    return created === 0
      ? this.translateService.instant('vbeiNoCreation')
      : `${created || ''} ` + this.translateService.instant('vbeiCreated');
  }

  private formatUpdatedInfo(updated: number): string {
    return updated === 0
      ? this.translateService.instant('vbeiNoUpdates')
      : `${updated || ''} ` + this.translateService.instant('vbeiUpdated');
  }

  private formatSuccessInfo(created: number, updated: number): string {
    const total = (created ?? 0) + (updated ?? 0);
    const key = this.isGroupUpload ? 'vbeiGroupsImportedSuccessfully' : 'vbeiImportedSuccessfully';
    return `${total} ${this.translateService.instant(key)}`;
  }

  private formatFailedInfo(): string {
    const errorCount = this.enTranslationMandatoryCount + this.nameCountMap.size;
    const key = this.isGroupUpload ? 'vbeiGroupSyntaxErrors' : 'vbeiSyntaxErrors';
    return `${errorCount} ${this.translateService.instant(key)}`;
  }

  public closeImportStatusDialog(): void {
    this.showImportStatusDialog = false;
  }

  public isProgressStatusValidForCompleted(progress: JobStatusDetail): boolean {
    return (
      progress.status === this.processStatus.Completed ||
      progress.status === this.processStatus.Partially ||
      progress.status === this.processStatus.Ready
    );
  }

  public isProgressStatusValid(progress: JobStatusDetail): boolean {
    if (!progress.name) {
      return false;
    }
    if (progress.id?.includes('DownloadLimitSetTemplate')) {
      this.isDownloadTemplateProcess = true;
      return progress.status === this.processStatus.Completed;
    } else if (progress.name?.includes(this.translateService.instant('vbeiDownloadLimitSet'))) {
      this.isDownloadCustomLimitSetProcess = true;
      return progress.status === this.processStatus.Completed;
    } else if (progress.name?.includes(this.translateService.instant('vbeiDownloadGroups'))) {
      this.isDownloadGroupsProcess = true;
      return progress.status === this.processStatus.Completed;
    } else {
      this.isDownloadTemplateProcess = false;
      this.isDownloadCustomLimitSetProcess = false;
      this.isDownloadTemplateProcess = false;
      this.isDownloadGroupsProcess = false;
      return (
        progress.status === this.processStatus.Completed ||
        progress.status === this.processStatus.Partially ||
        progress.status === this.processStatus.Failed
      );
    }
  }

  public updateErrorRuleNameCount(): void {
    this.nameCountMap.clear();
    this.enTranslationMandatoryCount = 0;
    this.validationDetails.forEach((validation: any) => {
      const hasRowNumber = validation?.customState?.rowNumber !== undefined && validation?.customState?.rowNumber !== 0;
      let uniqueName: string | undefined = undefined;
      uniqueName = this.areSchematicValidationRulesValid ? validation.customState.groupId : validation.customState.ruleName;
      if (uniqueName !== undefined && uniqueName !== null && uniqueName.trim() !== '') {
        this.nameCountMap.set(uniqueName, (this.nameCountMap.get(uniqueName) ?? 0) + 1);
      } else if (!hasRowNumber) {
        this.enTranslationMandatoryCount++;
      }
    });
  }

  public getProgressStatusTranslatedText(jobStatus: string): string {
    switch (jobStatus) {
      case JobStatus.Completed:
        return this.translateService.instant('vbeiCompletedStatus');
      case JobStatus.Partially:
        return this.translateService.instant('vbeiPartiallyCompletedStatus');
      case JobStatus.Active:
        return this.translateService.instant('vbeiActiveStatus');
      case JobStatus.Ready:
        return this.translateService.instant('vbeiReadyStatus');
      default:
        return this.translateService.instant('vbeiNewStatus');
    }
  }
}
